<template>
  <div class="container lesson-overview">
    <!-- <vue-custom-scrollbar  :style="`height: ${getScrollHeight()}`"> -->
    <div v-html="obj.info" class="tx-13 tx-color-02 bd-b mg-b-10"></div>
    <div class="mg-b-40" v-for="(b, i) in obj.boxes" :key="i">
      <div
        v-if="b.tasks.length || b.attaches.length || b.forms.length"
        class="d-flex justify-content-between"
      >
        <!-- <label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-0">
            {{b.nm}}
            {{b.ot}}
          </label> -->
        <h4
          class="mg-b-5 tx-color-02"
          :class="{ 'bd-b bd-5 pd-b-5 wd-100p': b.forms.length > 0 }"
        >
          {{ b.nm }}
        </h4>
        <span class="tx-12 tx-color-03" v-if="b.tasks.length">
          {{ b.tasks.filter(x => x.isCompleted).length }}/{{
            b.tasks.length
          }}
          ({{
            (
              (b.tasks.filter(x => x.isCompleted).length * 100) /
              b.tasks.length
            ).toFixed(2)
          }}%)
        </span>
        <span class="tx-12 tx-color-03" v-else-if="b.attaches.length">
          {{ b.attaches.filter(x => x.isCompleted).length }}/{{
            b.attaches.length
          }}
          ({{
            (
              (b.attaches.filter(x => x.isCompleted).length * 100) /
              b.attaches.length
            ).toFixed(2)
          }}%)
        </span>
      </div>

      <div v-if="b.tasks.length">
        <div class="progress ht-5">
          <div
            role="progressbar"
            :class="
              `progress-bar bg-${calcaulateProgressBg(
                b.tasks.filter(x => x.isCompleted).length,
                b.tasks.length
              )}`
            "
            :style="{
              width:
                (
                  (b.tasks.filter(x => x.isCompleted).length * 100) /
                  b.tasks.length
                ).toFixed(2) + '%'
            }"
          ></div>
        </div>
        <faq-list
          v-if="b.ot == 119"
          :tasks="b.tasks"
          :box="b"
          @on-detail="$emit('on-detail', { event: $event, box: b })"
        />
        <youtube-list
          v-else-if="b.ot == 122"
          :tasks="b.tasks"
          :box="b"
          @on-detail="$emit('on-detail', { event: $event, box: b })"
        />
        <embed-list
          v-else-if="b.ot == 422"
          :tasks="b.tasks"
          :box="b"
          @on-detail="$emit('on-detail', { event: $event, box: b })"
        />
        <html-list
          v-else-if="b.ot == 435"
          :tasks="b.tasks"
          :box="b"
          @on-detail="$emit('on-detail', { event: $event, box: b })"
        />
        <link-list v-else-if="b.ot == 127" :tasks="b.tasks" :box="b" />
      </div>
      <div v-if="b.forms.length">
        <form-list
          v-if="b.ot == 116 || b.ot == 117 || b.ot == 389 || b.ot == 416"
          :forms="b.forms"
          :box="b"
        />
      </div>
      <div v-if="b.attaches.length">
        <div class="progress ht-5">
          <div
            role="progressbar"
            :class="
              `progress-bar bg-${calcaulateProgressBg(
                b.attaches.filter(x => x.isCompleted).length,
                b.attaches.length
              )}`
            "
            :style="{
              width:
                (
                  (b.attaches.filter(x => x.isCompleted).length * 100) /
                  b.attaches.length
                ).toFixed(2) + '%'
            }"
          ></div>
        </div>
        <attachment-list
          v-if="b.ot == 6 || b.ot == 286"
          :box="b"
          :attachments="b.attaches"
          @on-detail="$emit('on-detail', { event: $event, box: b })"
        />
      </div>
    </div>
    <!-- </vue-custom-scrollbar> -->
  </div>
</template>

<script>
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";
// import vueCustomScrollbar from "vue-custom-scrollbar";

export default {
  components: {
    // vueCustomScrollbar,
    attachmentList: () => ({
      component: import(
        "@/views/modules/lms/student/sections/attachmentList.vue"
      ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    youtubeList: () => ({
      component: import("@/views/modules/lms/student/sections/youtubeList.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    formList: () => ({
      component: import("@/views/modules/lms/student/sections/formList.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    faqList: () => ({
      component: import("@/views/modules/lms/student/sections/faqList.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    embedList: () => ({
      component: import("@/views/modules/lms/student/sections/embedList.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    htmlList: () => ({
      component: import("@/views/modules/lms/student/sections/htmlList.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    linkList: () => ({
      component: import("@/views/modules/lms/student/sections/linkList.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    })
  },
  props: {
    obj: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    calcaulateProgressBg(now, all) {
      let rv = "secondary";
      let perc = (now * 100) / all;

      if (perc <= 9) {
        rv = "warning";
      } else if (perc <= 19) {
        rv = "gray-200";
      } else if (perc <= 29) {
        rv = "gray-300";
      } else if (perc <= 39) {
        rv = "gray-400";
      } else if (perc <= 49) {
        rv = "gray-500";
      } else if (perc <= 59) {
        rv = "gray-600";
      } else if (perc <= 69) {
        rv = "gray-700";
      } else if (perc <= 79) {
        rv = "gray-800";
      } else if (perc <= 89) {
        rv = "gray-900";
      } else if (perc <= 99) {
        rv = "gray-900";
      } else if (perc == 100) {
        rv = "success-light";
      }
      return rv;
    },
    getScrollHeight() {
      let mh = 170;
      if (screen.width <= 1024) {
        mh = 80;
      }
      return `calc(${window.innerHeight}px - ${mh}px);`;
    }
  }
};
</script>

<style></style>
